// extracted by mini-css-extract-plugin
module.exports = {"page":"SharingModal_page__zDbEB"};